<template>
	<div>
		<button class="btn btn-info btn-block" @click="newAnnotation" :disabled="$parent.viewer === null">{{ __('translations.button.add') }}</button>
		<hr class="mb-0" />
		<transition-group name="annotation" tag="div">
			<div v-for="(annotation, index) in artifact.annotations" class="card border-info my-3" :key="'annotation-' + annotation.id">
				<div v-lazyload class="image-wrapper my-3 px-3">
				    <div class="image-loader">
					    <div class="d-flex justify-content-center" style="height: 100%">
						    <div class="spinner-border text-secondary my-auto" role="status">
							  	<span class="sr-only">Loading...</span>
							</div>
						</div>
					</div>
				    <img :data-url="artifact.iiif_root + '/' + annotation.box_x + ',' + annotation.box_y + ',' + annotation.box_w + ',' + annotation.box_h + '/' + Math.min(annotation.box_w, 400) + ',/0/default.jpg'" class="image-item" />
				</div>
				<div class="card-body px-3 pb-3" v-show="annotation.transcription !== null || annotation.tags.length > 0">
					<table style="width: 100%; table-layout: fixed;">
						<tr v-show="annotation.tags.length > 0">
							<td class="align-top pr-4 text-muted" style="width: 32px;"><i class="fas fa-tags"></i></td>
							<td class="align-top annotation-tags">
								<span v-for="tag in annotation.tags" v-if="tag.action !== 'DELETE'" :key="tag.wikdiata_id" class="badge badge-tag">
									{{tag.wikidata_label}}
								</span>
							</td>
						</tr>
						<tr v-show="annotation.transcription !== null && annotation.transcription !== ''" class="pt-3">
							<td class="align-top pr-4 text-muted" style="width: 32px;"><i class="fas fa-font"></i></td>
							<td class="align-top text-preformatted" style="font-size: 14px;">{{annotation.transcription}}</td>
						</tr>
					</table>
				</div>
				<div class="card-footer d-flex justify-content-between px-3 py-2">
					<button class="btn btn-info btn-sm" style="width: 32px" @click="editAnnotation(annotation)" :disabled="$parent.viewer === null" data-toggle="tooltip" :title="__('translations.tooltip.edit')"><i class="far fa-edit fa-lg i-button align-middle"></i></button>
					<button class="btn btn-info btn-sm" style="width: 32px" @click="cloneAnnotation(annotation)" data-toggle="tooltip" :title="__('translations.tooltip.clone')"><i class="far fa-clone fa-lg i-button align-middle"></i></button>
					<b-button class="btn btn-danger btn-sm" style="width: 32px" @click="deleteAnnotation(annotation, index)" data-toggle="tooltip" :title="__('translations.tooltip.delete')"><i class="far fa-trash-alt fa-lg i-button align-middle"></i></b-button>
				</div>
			</div>
        </transition-group>
	</div>
</template>

<script>
import LazyLoadDirective from '../../directives/LazyLoadDirective';

export default {
	props: ['artifact'],
	directives: {
		lazyload: LazyLoadDirective
	},
	methods: {
		newAnnotation() {
			this.$emit('annotation-selected', { empty: true });
		},
		editAnnotation(annotation) {
			this.$emit('annotation-selected', annotation);
		},
		cloneAnnotation(annotation) {
			axios.post('/annotation/clone', {annotation: annotation}).then(response => {
				// Add the cloned annotation to the top of current list of annotations.
				this.artifact.annotations.unshift(response.data.clonedAnnotation);
				this.$parent.$refs['tab-content'].scrollTop = 0;
				this.$parent.updateAnnotations(this.artifact, response.data.allAnnotations);
			}).catch(err => {
				console.log(err)
			})
		},
		deleteAnnotation(annotation, index) {
			this.$bvModal.msgBoxConfirm(this.__('translations.message.delete_confirmation'), {
				okTitle: this.__('translations.button.ok'),
				cancelTitle: this.__('translations.button.cancel'),
				centered: true,
				noCloseOnBackdrop: true,
			}).then(confirmed => {
				if(confirmed) {
					axios.post('/annotation/delete', {annotation: annotation}).then(response => {
						// Update the current list of annotations.
						this.artifact.annotations.splice(index, 1);
						this.$parent.updateAnnotations(this.artifact, response.data.allAnnotations);
					}).catch(err => {
						console.log(err)
					})	
				}
			}).catch(err => {
				// An error occurred
			})
		}
	}
}
</script>